import * as React from 'react';
import { Image as ImageIcon, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import fallbackAvatar from 'assets/images/ChatBotAvatar.webp';
import { DMButton, DMDiv, DMImage, DMText } from './Primitives';

interface AvatarCardProps {
  avatarThumbnail?: string;
}

export const AvatarCard = ({ avatarThumbnail }: AvatarCardProps) => {
  const navigate = useNavigate();
  const avatarImage = avatarThumbnail || fallbackAvatar;

  const handleAvatarError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const target = event.currentTarget;

    if (!target.dataset.fallbackApplied) {
      target.dataset.fallbackApplied = 'true';
      target.src = fallbackAvatar;
    }
  };

  return (
    <DMDiv className="bg-white rounded-[2vh] border border-gray-200 p-[2.2vh] shadow-sm flex flex-col h-full">
      <DMDiv className="flex items-start justify-between mb-[1vh] gap-[1vh]">
        <DMDiv className="min-w-0">
          <DMText
            as="h3"
            className="text-[1.8vh] font-bold text-gray-800 leading-tight truncate shrink-0"
          >
            24/7 Virtual Admissions Counsellor
          </DMText>
          <DMText className="text-[1.6vh] text-gray-500 italic leading-tight mt-[0.5vh]">
            Always online. Never sleeps!! Multilingual support.
          </DMText>
        </DMDiv>
      </DMDiv>

      <DMDiv className="flex items-center justify-center gap-[2.5vh] mt-[1vh]">
        <DMDiv className="relative w-[20vh] h-[20vh] rounded-full p-[0.4vh] bg-gradient-to-tr from-pink-500 via-purple-500 to-orange-400 shrink-0">
          <DMDiv className="w-full h-full bg-white rounded-full overflow-hidden border-[0.2vh] border-white">
            <DMImage
              src={avatarImage}
              alt="Virtual Counsellor"
              className="w-full h-full object-cover"
              onError={handleAvatarError}
              referrerPolicy="no-referrer"
            />
          </DMDiv>
        </DMDiv>

        <DMDiv className="flex flex-col gap-[1.5vh] flex-1 justify-center">
          <DMButton
            type="button"
            onClick={() => navigate('/digital-marketing/avatar-selection')}
            className="flex items-center justify-center gap-[1vh] w-full py-[1.2vh] px-[2vh] border border-gray-200 rounded-[1vh] text-[1.8vh] font-bold text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <ImageIcon className="w-[2.2vh] h-[2.2vh] text-primary-main shrink-0" />
            <DMDiv className="h-[2.5vh] overflow-hidden flex flex-wrap justify-center content-start">
              <DMText as="span">Change</DMText>
              <DMText as="span" className="ml-[0.5vh]">
                Avatar
              </DMText>
            </DMDiv>
          </DMButton>
          <DMButton
            type="button"
            onClick={() =>
              navigate('/digital-marketing/avatar-selection/create')
            }
            className="flex items-center justify-center gap-[1vh] w-full py-[1.2vh] px-[2vh] border border-gray-200 rounded-[1vh] text-[1.8vh] font-bold text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Sparkles className="w-[2.2vh] h-[2.2vh] text-primary-main shrink-0" />
            <DMDiv className="h-[2.5vh] overflow-hidden flex flex-wrap justify-center content-start">
              <DMText as="span">Create</DMText>
              <DMText as="span" className="ml-[0.5vh]">
                Avatar
              </DMText>
            </DMDiv>
          </DMButton>
        </DMDiv>
      </DMDiv>
    </DMDiv>
  );
};

